import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    margin: theme.spacing(1),
  },

  topBar: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },

  form: {
    width: "auto",
  },

  select: {
    height: "auto",
    padding: 0,
  },

  thumbnail: {
    width: 200,
    height: 200,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },

  icon: {
    fontSize: "10rem",
  },
}));

const UserDetailsCard = ({ user, onChange }) => {
  const classes = useStyles();

  const handleTextChange = path => event => {
    const value = event.target.value;
    onChange(path, value);
  };

  return (
    <Card classes={{ root: classes.root }}>
      <Box className={classes.topBar}>
        <Box style={{ marginBottom: "10px" }}>
          <Typography variant="h2" color="primary" noWrap>
            User Profile
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={2}>
        <Grid item md={12}>
          <TextField
            fullWidth
            label="First Name"
            value={user.profile.firstName || ""}
            onChange={handleTextChange(["profile", "firstName"])}
          />
        </Grid>
        <Grid item md={12}>
          <TextField
            fullWidth
            label="Last Name"
            value={user.profile.lastName || ""}
            onChange={handleTextChange(["profile", "lastName"])}
          />
        </Grid>

        <Grid item md={6}>
          <FormControl fullWidth>
            <InputLabel htmlFor="content-view">Content View</InputLabel>
            <Select
              native
              value={user.profile.contentView}
              onChange={handleTextChange(["profile", "contentView"])}
              classes={{ select: classes.select }}
              inputProps={{
                name: "content-view",
                id: "content-view",
              }}
            >
              <option value="LIST">List</option>
              <option value="VISUAL">Visual</option>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Card>
  );
};

export default UserDetailsCard;
